import {
  Badge,
  Box,
  Button,
  HStack,
  Heading,
  Stack,
  Text,
} from "@chakra-ui/react"

import {
  useConfirmTopicSuggestion,
  useRejectTopicSuggestion,
  useTopicSuggestions,
} from "@/hooks/useTopicSuggestions"

interface Props {
  questionId: string
}

export function TopicSuggestionsReview({ questionId }: Props) {
  const { data, isLoading } = useTopicSuggestions("pending")
  const confirm = useConfirmTopicSuggestion()
  const reject = useRejectTopicSuggestion()

  if (isLoading) return null
  const items = data?.data?.filter((s) => s.question_id === questionId) ?? []
  if (items.length === 0) return null

  return (
    <Box mt={4} p={3} borderWidth="1px" borderRadius="md">
      <Heading size="sm" mb={2}>
        Suggested topics
      </Heading>
      <Stack gap={2}>
        {items.map((s) => (
          <HStack key={s.id} justify="space-between">
            <HStack>
              <Text fontWeight="medium">
                {s.topic_name ?? s.proposed_topic_name}
              </Text>
              {typeof s.score === "number" && (
                <Badge colorPalette="gray">{s.score.toFixed(2)}</Badge>
              )}
            </HStack>
            <HStack>
              <Button
                size="xs"
                colorPalette="green"
                loading={confirm.isPending}
                onClick={() => confirm.mutate(s.id)}
              >
                Confirm
              </Button>
              <Button
                size="xs"
                variant="outline"
                loading={reject.isPending}
                onClick={() => reject.mutate(s.id)}
              >
                Reject
              </Button>
            </HStack>
          </HStack>
        ))}
      </Stack>
    </Box>
  )
}
